import React, { useState, useEffect } from 'react';
import PostCard from '../components/PostCard';
import LoadingSpinner from '../components/ui/LoadingSpinner';
import ErrorMessage from '../components/ui/ErrorMessage';
import EmptyState from '../components/ui/EmptyState';
import './Noticeboard.css';

const USEFUL_LINKS = [
  {
    heading: 'Bins & Recycling',
    links: [
      { label: 'Check your bin day', href: 'https://www.stalbans.gov.uk/bins-and-recycling/bin-collection-days' },
      { label: 'Household waste & recycling sites', href: 'https://www.hertfordshire.gov.uk/services/recycling-waste-and-environment/recycling-and-waste/tips-and-recycling-centres/tips-and-recycling-centres.aspx' },
    ],
  },
  {
    heading: 'Report a Problem',
    links: [
      { label: 'Report a pothole', href: 'https://www.hertfordshire.gov.uk/services/roads-pavements-and-transport/road-transport-and-infrastructure/potholes/potholes.aspx' },
      { label: 'Non-emergency police report', href: 'https://www.herts.police.uk/advice/advice-and-information/rs/reporting-something/' },
    ],
  },
  {
    heading: 'Local Services',
    links: [
      { label: 'St Albans City & District Council', href: 'https://www.stalbans.gov.uk' },
      { label: 'Hertfordshire County Council', href: 'https://www.hertfordshire.gov.uk' },
      { label: 'St Albans libraries', href: 'https://www.hertfordshire.gov.uk/services/libraries-and-archives/libraries/find-a-library.aspx' },
      { label: 'Civic Centre information', href: 'https://www.stalbans.gov.uk/council-and-democracy/contact-us' },
    ],
  },
  {
    heading: 'Schools & Families',
    links: [
      { label: 'School admissions', href: 'https://www.hertfordshire.gov.uk/services/schools-and-education/school-admissions/school-admissions.aspx' },
      { label: 'Care & safeguarding', href: 'https://www.hertfordshire.gov.uk/services/childrens-social-care-and-health/child-protection-and-safeguarding/child-protection-and-safeguarding.aspx' },
    ],
  },
];

const Noticeboard = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    fetch('/api/news')
      .then(res => {
        if (!res.ok) throw new Error('Failed to load noticeboard');
        return res.json();
      })
      .then(data => { if (mounted) setPosts(Array.isArray(data) ? data : []); })
      .catch(e => { if (mounted) setError(e.message); })
      .finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, []);

  return (
    <div className="noticeboard-page">
      <section className="page-intro wrap">
        <span className="kicker">What's on · what's changing</span>
        <h1>The noticeboard</h1>
        <p className="lead" style={{ maxWidth: 640 }}>
          Everything happening around Carlisle &amp; Waverley — updates to put in the diary
          and notices worth knowing about.
        </p>
      </section>

      <div className="noticeboard-layout wrap section-tight">
        <div className="noticeboard-main">
          {loading && <LoadingSpinner />}
          {error && <ErrorMessage message={error} />}
          {!loading && !error && posts.length === 0 && (
            <EmptyState message="Nothing posted yet — check back soon." />
          )}
          {posts.length > 0 && (
            <div className="board-grid-nb">
              {posts.map((post, i) => (
                <PostCard key={post.id || i} post={post} index={i} />
              ))}
            </div>
          )}
        </div>

        <aside className="noticeboard-sidebar">
          <h2>Useful Links</h2>
          <p className="muted" style={{ marginBottom: 16, fontSize: '0.9rem' }}>
            Handy local services and resources.
          </p>
          {USEFUL_LINKS.map(({ heading, links }) => (
            <div className="sidebar-group" key={heading}>
              <h3>{heading}</h3>
              <ul>
                {links.map(({ label, href }) => (
                  <li key={label}>
                    <a href={href} target="_blank" rel="noreferrer">{label}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <p className="muted" style={{ fontSize: '0.85rem', marginTop: 12 }}>
            Links need updating? <a href="/contact">Let us know.</a>
          </p>
        </aside>
      </div>
    </div>
  );
};

export default Noticeboard;
